import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { CSAuth } from "../../../../tools/authentication";
import { Alert, Button } from "tabler-react";
import { useQuery } from "@apollo/client";
import GET_USER_PROFILE from "../../../../queries/system/get_user_profile";

import ShopBase from "../../ShopBase";

function ShopClassesScheduleBase({
    t,
    match,
    history,
    children,
    pageHeaderOptions = "",
}) {
    const [userIsAuthenticated, setUserIsAuthenticated] = useState(
        CSAuth.isAuthenticated() && CSAuth.isRefreshTokenValid(),
    );

    // Query user data if authenticated
    const { loading, data } = useQuery(GET_USER_PROFILE, {
        skip: !userIsAuthenticated,
        fetchPolicy: "network-only",
    });

    // Check for token expiration on component mount
    useEffect(() => {
        // If not authenticated and we have a refresh token flag active, clean up
        if (
            window.refreshingToken &&
            !CSAuth.isAuthenticated() &&
            !CSAuth.isRefreshTokenValid()
        ) {
            console.log(
                "Cleaning up stale token state in ShopClassesScheduleBase",
            );
            CSAuth.cleanup();
            setUserIsAuthenticated(false);
        }

        // Update auth state when component mounts
        setUserIsAuthenticated(
            CSAuth.isAuthenticated() && CSAuth.isRefreshTokenValid(),
        );
    }, []);

    return (
        <ShopBase
            title={t("shop.classes.title")}
            pageHeaderOptions={pageHeaderOptions}
        >
            <div className="mb-4">
                {!userIsAuthenticated ? (
                    <Alert type="primary">
                        <Link to="/user/login">
                            <Button color="primary" size="sm" className="mr-2">
                                {t("general.sign_in")}
                            </Button>
                        </Link>
                        {t("shop.classes.login_to_book_classes")}
                    </Alert>
                ) : (
                    !loading &&
                    data &&
                    data.user && (
                        <Alert type="success">
                            {t("general.welcome")}, {data.user.fullName}
                            <div className="float-right">
                                <Link to="/shop/account">
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        outline
                                        icon="user"
                                    >
                                        {t("shop.account.title")}
                                    </Button>
                                </Link>
                            </div>
                        </Alert>
                    )
                )}
            </div>
            {children}
        </ShopBase>
    );
}

export default withTranslation()(withRouter(ShopClassesScheduleBase));
